// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapIcon } from '../../../dsl/front';
let ReactionsCount = class ReactionsCount extends Vue {
};
__decorate([
    Prop({ type: Number, required: false, default: 0 })
], ReactionsCount.prototype, "comments", void 0);
__decorate([
    Prop({ type: Number, required: false, default: 0 })
], ReactionsCount.prototype, "likes", void 0);
ReactionsCount = __decorate([
    Component({
        name: 'ReactionsCount',
        components: { BootstrapIcon },
        template: `
    <div class="reactions-count">
      <div class="reactions-count__item">
        <BootstrapIcon name="like-new" />
        {{ likes ? likes : '' }}
      </div>

      <div class="reactions-count__item">
        <BootstrapIcon name="comment-new" />
        {{ comments ? comments : '' }}
      </div>
    </div>
  `
    })
], ReactionsCount);
export { ReactionsCount };
